var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Card, CardBody, CardMedia, Link, Typography, } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useEffect, useRef, useState } from 'react';
import { GetOrderDetailsAPI } from '../../../api/oms/order-details';
import { GetDeliveryTrackerInfo } from '../../../hooks/delivery-tracker-hooks';
import { usePurchaseHistoryContext, useExperienceContext, } from '../../../hooks/useContexts';
import { generateImageUrl, routeBuilder } from '../../../utils/general';
import { retrieveSelectedOrderDetail } from '../../../utils/purchase-history/helpers';
import { pushOrderDetailsOrderCardEvent } from '../../../utils/purchase-history/analytics';
import { separateReturnedFG } from '../../../utils/returns/returns-fg-helper';
import { dateFormat } from '../../order-details/util/format';
import { PHOrderDetailsAndActions } from '../delivery-tracker/PHOrderDetailsAndActions';
import { CardHeader } from './CardHeader';
import { PHCardDetailSkeleton } from './CardSkeletonLoader';
import './PHCard.scss';
var getOrderType = function (orderNumber) {
    if (orderNumber && (orderNumber[0] === 'W' || orderNumber[0] === 'C')) {
        return 'ONLINE';
    }
    return 'INSTORE';
};
var generateOrderDetailsRequest = function (order, customerType, svocID, requestOriginatedFrom) {
    var transactionType = order.transactionType, transactionId = order.transactionId, registerNumber = order.registerNumber, salesDate = order.salesDate, storeNumber = order.storeNumber, orderNumber = order.orderNumber, orderNumbers = order.orderNumbers;
    var filteredOrderNumber = orderNumber !== null && orderNumber !== void 0 ? orderNumber : orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0];
    var orderType = getOrderType(filteredOrderNumber);
    if (customerType === 'b2b' && orderType === 'ONLINE') {
        if (transactionType === 'R') {
            return {
                orderDetailsRequest: {
                    searchType: 'online',
                    registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                    salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                    storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                    transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                    transactionType: transactionType !== null && transactionType !== void 0 ? transactionType : '',
                    orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                    customerAccountId: svocID,
                    groupAndSortBy: {
                        groupBy: 'fulfillmentType',
                        filterResponse: true,
                    },
                    requestOriginatedFrom: requestOriginatedFrom,
                },
            };
        }
        return {
            orderDetailsRequest: {
                searchType: 'online',
                orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                customerAccountId: svocID,
                groupAndSortBy: {
                    groupBy: 'fulfillmentType',
                    filterResponse: true,
                },
                requestOriginatedFrom: requestOriginatedFrom,
            },
        };
    }
    if (orderType === 'INSTORE') {
        return {
            orderDetailsRequest: {
                searchType: 'instore',
                registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                customerAccountId: svocID,
                groupAndSortBy: {
                    groupBy: 'fulfillmentType',
                    filterResponse: true,
                },
                requestOriginatedFrom: requestOriginatedFrom,
            },
        };
    }
    return {
        orderDetailsRequest: {
            searchType: orderType === null || orderType === void 0 ? void 0 : orderType.toLowerCase(),
            orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
            requestOriginatedFrom: requestOriginatedFrom,
        },
    };
};
export var orderDetailView = function (orderDetails, orderDetailsLoaded, record) {
    var _a, _b, _c, _d;
    if (!orderDetailsLoaded) {
        return (React.createElement(React.Fragment, null,
            React.createElement(PHCardDetailSkeleton, { numberOfSkeletons: 1 })));
    }
    if (orderDetails) {
        var orderedGroups = separateReturnedFG(orderDetails.fulfillmentGroups).orderedGroups;
        var orderNumber_1 = (_c = (_a = record === null || record === void 0 ? void 0 : record.orderNumber) !== null && _a !== void 0 ? _a : (_b = record === null || record === void 0 ? void 0 : record.orderNumbers) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : '';
        var canceledLineItems = orderedGroups.flatMap(function (fg) {
            return fg.lineItems && fg.cancellationStatus !== 'OUT_OF_STOCK'
                ? fg.lineItems.filter(function (item) { return item.statusDescription === 'Canceled'; })
                : [];
        });
        return (React.createElement("div", null, orderedGroups === null || orderedGroups === void 0 ? void 0 :
            orderedGroups.map(function (fg, indexFG) {
                if (fg.lineItems &&
                    fg.cancellationStatus !== 'OUT_OF_STOCK' &&
                    fg.lineItems.every(function (item) { return item.statusDescription === 'Canceled'; })) {
                    return null;
                }
                return (React.createElement("div", { className: "".concat(indexFG > 0 ? 'sui-mt-8' : '') },
                    React.createElement(PHOrderDetailsAndActions, { emailId: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.emailId, fulfillmentGroup: fg, net: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.net) || '', orderDetailsLoaded: orderDetailsLoaded, orderNumber: orderNumber_1, salesDate: record === null || record === void 0 ? void 0 : record.salesDate, variant: "card", isPTCOrder: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.isPTCOrder })));
            }),
            canceledLineItems.length > 0 && (React.createElement("div", { className: "sui-flex sui-w-full sui-flex-col sui-gap-0 sui-min-w-[330px] md:sui-min-w-[422px] sui-mt-2" },
                React.createElement("div", { className: "sui-flex sui-flex-col" },
                    React.createElement(Typography, { variant: "body-base", weight: "bold", style: {
                            textTransform: 'capitalize',
                            marginBottom: '12px',
                        } }, "Canceled ".concat(dateFormat((_d = canceledLineItems === null || canceledLineItems === void 0 ? void 0 : canceledLineItems[0]) === null || _d === void 0 ? void 0 : _d.statusUpdatedDate, 'MMMM d')))),
                React.createElement("div", null,
                    React.createElement("div", { className: "sui-flex sui-items-center sui-relative sui-gap-[16px]", style: {
                            width: '48px',
                            height: '48px',
                        } }, canceledLineItems.map(function (lineItem, idx) { return (React.createElement("div", { key: idx, style: {
                            overflow: 'hidden',
                            minWidth: '48px',
                            height: '48px',
                        } },
                        React.createElement(CardMedia, { src: generateImageUrl(lineItem), alt: lineItem
                                ? lineItem === null || lineItem === void 0 ? void 0 : lineItem.description
                                : 'Unavailable image' }))); })))))));
    }
    return null;
};
export var PHCard = function (_a) {
    var customerRole = _a.customerRole, customerType = _a.customerType, record = _a.record, index = _a.index;
    var _b = usePurchaseHistoryContext(), allOrderDetails = _b.allOrderDetails, setAllOrderDetails = _b.setAllOrderDetails, cpsDataSource = _b.cpsDataSource;
    var channel = useExperienceContext().channel;
    // TODO - needs to be used or removed. i.e. any error handling UI, etc.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _c = useState(null), orderDetailsError = _c[0], setOrderDetailsError = _c[1];
    var _d = useState(false), orderDetailsLoaded = _d[0], setOrderDetailsLoaded = _d[1];
    var _e = useState(false), isLoadingOrderDetails = _e[0], setIsLoadingOrderDetails = _e[1];
    var sentinelRef = useRef(null);
    var svocID = useThdCustomer().svocID;
    var registerNumber = record.registerNumber, orderNumber = record.orderNumber, orderNumbers = record.orderNumbers, POJobName = record.POJobName, projectName = record.projectName, receiptDetails = record.receiptDetails, returnTotal = record.returnTotal, salesDate = record.salesDate, totalAmount = record.totalAmount, transactionId = record.transactionId, transactionIdWithCheckDigit = record.transactionIdWithCheckDigit;
    var selectedOrderDetail = retrieveSelectedOrderDetail(record, allOrderDetails, customerType, cpsDataSource);
    useEffect(function () {
        if (selectedOrderDetail) {
            setOrderDetailsLoaded(true);
        }
        var observer = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            if (entry.isIntersecting &&
                !orderDetailsLoaded &&
                !selectedOrderDetail &&
                !isLoadingOrderDetails) {
                setIsLoadingOrderDetails(true);
                GetOrderDetailsAPI(customerType, customerRole || '', generateOrderDetailsRequest(record, customerType, svocID, 'purchaseHistory'), channel)
                    .then(function (response) {
                    GetDeliveryTrackerInfo(response.data).then(function (deliveryTrackingData) {
                        setAllOrderDetails(function (prevDetails) {
                            return deliveryTrackingData
                                ? __spreadArray(__spreadArray([], prevDetails, true), [
                                    deliveryTrackingData,
                                ], false) : prevDetails;
                        });
                    });
                })
                    .catch(function (error) {
                    setOrderDetailsError(error);
                })
                    .finally(function () {
                    setOrderDetailsLoaded(true);
                    setIsLoadingOrderDetails(false);
                });
            }
        }, { rootMargin: '0px 0px 100% 0px', threshold: 1 });
        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }
        return function () {
            if (sentinelRef.current) {
                observer.unobserve(sentinelRef.current);
            }
        };
    }, [orderDetailsLoaded, isLoadingOrderDetails, selectedOrderDetail]);
    var orderDetailsLink = "/myaccount/order-details".concat(routeBuilder(__assign({ index: index }, record)));
    var handleCardClick = function () {
        pushOrderDetailsOrderCardEvent();
    };
    return (React.createElement("div", { className: "sui-mb-[24px] card-edits" },
        React.createElement("div", { ref: sentinelRef, "data-testid": "sentinel-ref" }),
        React.createElement(Link, { href: orderDetailsLink },
            React.createElement(Card, { className: "sui-shadow-none sui-border-[rgb(204, 204, 203)] sui-rounded-sm", onClick: handleCardClick },
                React.createElement(CardHeader, { isRefund: (returnTotal !== null && returnTotal !== void 0 ? returnTotal : 0) > 0, orderNumber: (orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) || orderNumber || receiptDetails, POJobName: POJobName || '', projectName: projectName, registerNumber: registerNumber, salesDate: salesDate, totalAmount: totalAmount, transactionId: transactionIdWithCheckDigit || transactionId, cpsDataSource: cpsDataSource, statusDescription: selectedOrderDetail === null || selectedOrderDetail === void 0 ? void 0 : selectedOrderDetail.statusDescription }),
                React.createElement(CardBody, null,
                    React.createElement("div", null, orderDetailView(selectedOrderDetail, orderDetailsLoaded, record)))))));
};
